import React, { useContext, useEffect } from 'react'
import DeviceTabs from './DeviceTabs';
import './Device.css';
import HeaderToolbar from '../../components/HeaderToolbar';
import { useTranslation } from 'react-i18next';
import { ThemeContext } from '../../theme/ThemeContext';
function Device() {
  const { t } = useTranslation();
  const { darkMode } = useContext(ThemeContext);

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('darkMode');
    } else {
      document.body.classList.remove('darkMode');
    }
    return () => {
      document.body.classList.remove('darkMode');
    };
  }, [darkMode]);

  return (
    <>
      <HeaderToolbar
        title={t('VISACCDEV009')}
      />
      <div style={{ marginTop: '8px'}}>
        <DeviceTabs />
      </div>
    </>
  )
}

export default Device